export default class CorePermission {
  constructor(parent) {
    this.$parent = parent;
    this.data = [];
    this.partner = null;
    this.legal = null;
    this.user = null;
    this.region = null;
    this.office = null;
    this.authentication = null;
    this.tariff = null;
  }

  get(arg) {
    return this.data.indexOf(arg) >= 0;
  }

  has(arg) {
    if (!arg) return true;
    return this.data.indexOf(arg) >= 0;
  }

  hasAny(...args) {
    if (!args) return true;
    if (!args.length) return true;
    return !!args.find(i => this.has(i));
  }

  hasAll(...args) {
    if (!args) return true;
    if (!args.length) return true;
    return !args.find(i => !this.has(i));
  }

  set(data) {
    this.data = data || [];
  }
}
